module.exports = __webpack_public_path__ + "141d4a85/img/mini-logo.18817ee5.svg";